/* ==========================================================================
   PICK, DON'T TYPE

   Step 2 leads with the sizes we actually make, as buttons, built live from
   the catalog for whichever furniture was picked. Choosing "58 to 67 inches"
   is a recognition task; typing 63.5 is a recall task, and recognition wins,
   particularly for anyone not yet sure what to measure.

   IN SEAT TERMS. The width chips are the width bands. The depth chips are the
   seat depths each size is made for (seatLo to seatHi from #bh-catalog, the
   same numbers the product page and the cart show), with the size number
   underneath. Nothing here names a board measurement.

   The list of ranges a tile may offer is NOT decided here. It comes from
   poolFor() in size-logic.js, the same function the matcher uses, so a chip
   can never offer a size the matcher would refuse.

   "My width isn't listed" opens the typed fields under "Not sure?" and puts
   the cursor in the width box. Typing is always there, and the finder answers
   any width honestly, including "we don't make that exactly".

   The chips render into #pickmount, which Liquid prints in the right place.
   If the chips ever vanish, check that #pickmount exists.
   ========================================================================== */
(function(){
  var INCH = '″';

  function el(id){ return document.getElementById(id); }
  function fmt(n){ return String(Math.round(Number(n) * 100) / 100); }
  function catalog(){ return (typeof CATALOG !== 'undefined' && Array.isArray(CATALOG)) ? CATALOG : []; }
  function nearby(node){ try { node.scrollIntoView({block:'nearest', behavior:'smooth'}); } catch(e){} }

  /* Single source of truth, shared with the matcher. The fallback only fires
     if size-logic.js failed to load, and a narrow step 2 is better than none. */
  function poolOf(type){
    if(typeof poolFor === 'function') return poolFor(type);
    return catalog().filter(function(p){ return p.type === type; });
  }

  /* from = the furniture type the row belongs to. A band borrowed from
     another type (Sofa offers the first Long sofa band) says so under the
     chip, so the buyer knows either tile leads to the same board. */
  function bandsFor(type){
    var seen = {}, out = [];
    poolOf(type).forEach(function(p){
      var k = p.min + '-' + p.max;
      if(!seen[k]){ seen[k] = 1; out.push({min:p.min, max:p.max, from:p.type}); }
    });
    return out.sort(function(a, b){ return a.min - b.min; });
  }

  function typeName(t){
    try { if(typeof LABEL !== 'undefined' && LABEL && LABEL[t]) return LABEL[t]; } catch(e){}
    return t === 'sofa-long' ? 'Long sofa' : '';
  }

  function depthsFor(type, band){
    var seen = {}, out = [];
    poolOf(type).forEach(function(p){
      if(band && (p.min !== band.min || p.max !== band.max)) return;
      if(!seen[p.depth]){ seen[p.depth] = 1; out.push(p.depth); }
    });
    return out.sort(function(a, b){ return a - b; });
  }

  function rowFor(type, band, depth){
    var rows = poolOf(type).filter(function(p){
      return p.min === band.min && p.max === band.max && p.depth === depth;
    });
    return rows[0] || null;
  }

  function seatOfRow(p){
    if(typeof window.bhSeatOf === 'function') return window.bhSeatOf(p);
    var lo = Number(p.seatLo), hi = Number(p.seatHi);
    return (lo > 0 && hi >= lo) ? {lo:lo, hi:hi} : {lo:p.depth, hi:p.depth};
  }

  /* Somebody who answered with the buttons never typed a chaise width, so we
     fill in the middle of the range the set covers. It is inside the range by
     definition, which is what the matcher needs to hand back the set. */
  function chaiseMidpoint(band){
    var sets = catalog().filter(function(p){
      if(p.type !== 'sectional') return false;
      return !band || (p.min === band.min && p.max === band.max);
    });
    for(var i = 0; i < sets.length; i++){
      var lo = sets[i].chaiseMin != null ? sets[i].chaiseMin : sets[i].chaise;
      var hi = sets[i].chaiseMax != null ? sets[i].chaiseMax : sets[i].chaise;
      if(lo != null && hi != null) return (lo + hi) / 2;
    }
    return null;
  }

  /* The chaise range our sets cover, across every set in stock. */
  function chaiseRange(){
    var lo = null, hi = null;
    catalog().forEach(function(p){
      if(p.type !== 'sectional') return;
      var a = p.chaiseMin != null ? p.chaiseMin : p.chaise;
      var b = p.chaiseMax != null ? p.chaiseMax : p.chaise;
      if(a == null || b == null) return;
      lo = lo == null ? a : Math.min(lo, a);
      hi = hi == null ? b : Math.max(hi, b);
    });
    return (lo == null || hi == null) ? null : {lo:lo, hi:hi};
  }

  function chip(label, sub, event, params){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pick bh-chip';
    b.setAttribute('aria-pressed', 'false');
    var strong = document.createElement('b');
    strong.textContent = label;
    b.appendChild(strong);
    if(sub){
      var small = document.createElement('small');
      small.textContent = sub;
      b.appendChild(small);
    }
    if(event){
      b.setAttribute('data-bh-event', event);
      if(params) b.setAttribute('data-bh-params', JSON.stringify(params));
    }
    return b;
  }

  function press(row, btn){
    row.querySelectorAll('.pick:not(.pick-manual)').forEach(function(x){
      x.classList.remove('on'); x.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true');
  }

  function openTyped(focusId){
    focusId = typeof focusId === 'string' ? focusId : 'w';
    if(typeof window.bhFinderManual === 'function'){ window.bhFinderManual(focusId); return; }
    var m = document.querySelector('#finder details.manual');
    if(m) m.open = true;
    var f = el(focusId);
    if(f) setTimeout(function(){ try { f.focus(); } catch(e){} }, 60);
  }

  function submit(chosen){
    var wEl = el('w'), dEl = el('d'), cEl = el('c'), calc = el('calc');
    if(!chosen.band || chosen.depth == null || !wEl || !dEl || !calc) return;
    // Midpoint of the chosen band: inside the range by definition, so the
    // matcher returns that exact size rather than a near miss.
    wEl.value = ((chosen.band.min + chosen.band.max) / 2).toFixed(1);
    dEl.value = chosen.depth;
    if(cEl) cEl.value = chosen.chaise != null ? chosen.chaise : '';
    calc.setAttribute('data-via', 'chips');
    calc.click();
  }

  /* "Show me how to measure": a closed <details> under the width hint and
     another under the depth question, so the chips stay on screen 1 and the
     drawing is one tap away. The drawings are inert <template>s printed once
     by size-finder.liquid (#bh-dm-width, #bh-dm-recliner, #bh-dm-sectional,
     #bh-dm-depth), from the same diagram-measure snippet as the guide and the
     product page. A recliner gets the narrowest-point drawing and a sectional
     the L-shape instead of the plain width. No template, no panel. */
  function howPanel(tplId, label, placement, type){
    var tpl = el(tplId);
    if(!tpl || !tpl.content) return null;
    var d = document.createElement('details');
    d.className = 'how pickhow';
    var s = document.createElement('summary');
    s.textContent = label;
    s.setAttribute('data-bh-event', 'bh_measuring_guide');
    s.setAttribute('data-bh-params', JSON.stringify({placement:placement, furniture_type:type}));
    d.appendChild(s);
    try { d.appendChild(document.importNode(tpl.content, true)); } catch(e){ return null; }
    return d;
  }

  function build(type){
    var mount = el('pickmount');
    type = type || ((typeof sel !== 'undefined' && sel) ? sel.type : null);
    if(!mount || !type) return;
    mount.innerHTML = '';

    var chosen = {band:null, depth:null, chaise:null};
    var isSec = type === 'sectional';

    var wHead = document.createElement('h4');
    wHead.className = 'pickhead';
    wHead.id = 'pick-w-h';
    wHead.textContent = isSec ? 'How wide is the main run, inside the arms?' : 'How wide is the seat, inside the arms?';
    mount.appendChild(wHead);

    if(isSec){
      var cr = chaiseRange();
      if(cr){
        var note = document.createElement('p');
        note.className = 'bh-note picknote';
        note.appendChild(document.createTextNode('Our sectional sets include a chaise board for a chaise section '
          + fmt(cr.lo) + INCH + ' to ' + fmt(cr.hi) + INCH
          + ' wide, at the same seat depth as the main run. If your chaise is a different size, '));
        var typeLink = document.createElement('button');
        typeLink.type = 'button';
        typeLink.className = 'pick-inline';
        typeLink.textContent = 'type your numbers instead';
        typeLink.setAttribute('data-bh-event', 'bh_manual_entry');
        typeLink.setAttribute('data-bh-params', JSON.stringify({furniture_type:type, placement:'chaise_note'}));
        typeLink.addEventListener('click', function(){ openTyped('c'); });
        note.appendChild(typeLink);
        note.appendChild(document.createTextNode('.'));
        mount.appendChild(note);
      }
    }

    /* Each measuring idea is said once on this screen: "bare seat base" in
       the step heading, "cushions off" in its subheading, the width question
       names "inside the arms" and the depth question "front edge to
       backrest". The hint only adds the action, and the recliner exception. */
    var hint = document.createElement('p');
    hint.className = 'pickhint';
    hint.textContent = type === 'recliner'
      ? 'On a recliner, measure the narrowest point between the arms, then tap the range.'
      : 'Measure it, then tap the range your number falls into.';
    mount.appendChild(hint);

    var wTpl = type === 'recliner' ? 'bh-dm-recliner' : (isSec ? 'bh-dm-sectional' : 'bh-dm-width');
    var wHow = howPanel(wTpl, 'Show me how to measure', 'finder_width', type);
    if(wHow) mount.appendChild(wHow);

    var wRow = document.createElement('div');
    wRow.className = 'pickrow';
    wRow.setAttribute('role', 'group');
    wRow.setAttribute('aria-labelledby', 'pick-w-h');
    mount.appendChild(wRow);

    var dHead = document.createElement('h4');
    dHead.className = 'pickhead';
    dHead.id = 'pick-d-h';
    dHead.textContent = 'How deep is the seat, front edge to backrest?';
    var dRow = document.createElement('div');
    dRow.className = 'pickrow';
    dRow.setAttribute('role', 'group');
    dRow.setAttribute('aria-labelledby', 'pick-d-h');
    var dHow = howPanel('bh-dm-depth', 'Show me how to measure depth', 'finder_depth', type);
    // The depth question, its drawing and its chips show and hide together.
    function showDepth(on){
      dHead.hidden = !on; dRow.hidden = !on;
      if(dHow) dHow.hidden = !on;
    }
    showDepth(false);
    mount.appendChild(dHead);
    if(dHow) mount.appendChild(dHow);
    mount.appendChild(dRow);

    bandsFor(type).forEach(function(band){
      var other = band.from && band.from !== type ? typeName(band.from) : '';
      var b = chip(fmt(band.min) + INCH + ' to ' + fmt(band.max) + INCH, other ? 'wide, same as ' + other : 'wide', 'bh_finder_width',
                   {furniture_type:type, choice:fmt(band.min) + '-' + fmt(band.max)});
      b.addEventListener('click', function(){
        chosen.band = band; chosen.depth = null; chosen.chaise = null;
        press(wRow, b);
        dRow.innerHTML = '';
        var depths = depthsFor(type, band);

        /* ONE DEPTH IS NOT A QUESTION. Some widths are made in a single size,
           so there is nothing to ask. submit() writes the same depth the
           single button would have written, and the card shows the seat
           depths that size is made for. Decided by count, not by furniture,
           so a second depth turns the step back on with no code change. */
        if(depths.length === 1){
          chosen.depth = depths[0];
          if(isSec) chosen.chaise = chaiseMidpoint(band);
          showDepth(false);
          setTimeout(function(){ submit(chosen); }, 160);
          return;
        }
        if(!depths.length){ showDepth(false); return; }

        depths.forEach(function(depth){
          var row = rowFor(type, band, depth);
          var s = row ? seatOfRow(row) : {lo:depth, hi:depth};
          var d = chip(fmt(s.lo) + INCH + ' to ' + fmt(s.hi) + INCH, 'size ' + fmt(depth), 'bh_finder_depth',
                       {furniture_type:type, choice:fmt(depth)});
          d.addEventListener('click', function(){
            chosen.depth = depth;
            press(dRow, d);
            if(isSec) chosen.chaise = chaiseMidpoint(band);
            setTimeout(function(){ submit(chosen); }, 160);
          });
          dRow.appendChild(d);
        });
        showDepth(true);
        nearby(dHead);
      });
      wRow.appendChild(b);
    });

    // The way out for a width we do not list: type it, and the finder answers.
    var manual = chip("My width isn't listed", 'Type your numbers', 'bh_manual_entry', {furniture_type:type});
    manual.classList.add('pick-manual');
    manual.removeAttribute('aria-pressed');
    manual.addEventListener('click', function(){ openTyped('w'); });
    wRow.appendChild(manual);
  }

  // Called by size-finder-ui.js whenever a furniture type is chosen, from a
  // tile or from the address. Defined now so it exists before DOMContentLoaded.
  window.bhPickerBuild = build;

  function init(){
    var mount = el('pickmount');
    if(!mount || mount.childNodes.length) return;
    if(typeof sel !== 'undefined' && sel && sel.type) build(sel.type);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
